export const INTRO_STEP = "welcome";
export const CONSENT_STEP = "consent";
export const PHONE_STEP = "phoneNumber";
export const FACE_STEP = "face";
export const DOCUMENT_STEP = "document";
export const LIVENESS_STEP = "liveness";
export const COMPLETE_STEP = "complete";
export const NFC_STEP = "nfc";
